import React from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card, Badge, Spinner, Table,
    CardHeader, Collapse, Modal,

    Row, Label,
    Col,
    Container,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";


function CreateVInfo(props) {


    try {
        return (

            <Modal isOpen={props.infom} style={{ marginTop: -40, minWidth: "80%" }}>

                <Row style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}><Col>Listing ID : {props.vehicle.luid}</Col><Col ><span style={{ float: "right" }}><i><b>{props.vehicle.listingType}</b></i></span></Col></Row>

                <ModalBody>
                    <hr />
                    <Row>
                        <Col>
                            <Row style={{ marginTop: 10 }}>
                                <Col md="6">
                                    <center><img alt="..." width={"140px"} src={`${props.vehicle.imgmc}`} style={{ cursor: "pointer" }} /> </center>
                                </Col>
                                <Col md="6">
                                    <Row>
                                        <Col md="6"><center><img alt="..." width={"80px"} src={`${props.vehicle.imgpc[0]}`} style={{ cursor: "pointer" }} /> </center></Col>
                                        <Col md="6"><center><img alt="..." width={"80px"} src={`${props.vehicle.imgpc[1]}`} style={{ cursor: "pointer" }} /> </center></Col>
                                    </Row>
                                    <Row style={{ marginTop: 10 }}>
                                        <Col md="6"><center><img alt="..." width={"80px"} src={`${props.vehicle.imgpc[2]}`} style={{ cursor: "pointer" }} /> </center></Col>
                                        <Col md="6"><center><img alt="..." width={"80px"} src={`${props.vehicle.imgpc[3]}`} style={{ cursor: "pointer" }} /> </center></Col>
                                    </Row>
                                </Col>
                            </Row>


                            <Row style={{ textAlign: "center", marginTop: 10 }}>
                                <Col md="4">Brand  <h6>{props.vehicle.bname.en} - {props.vehicle.bname.ar}</h6> </Col>
                                <Col md="4">Model  <h6>{props.vehicle.mname.en} - {props.vehicle.mname.ar}</h6> </Col>
                                <Col md="4">Year  <h6>{props.vehicle.modelyear.label}</h6></Col>

                            </Row>
                            <Row>
                                <Col md="6">V.Type  <h6>{props.vehicle?.vtname.en} - {props.vehicle.vtname.ar}</h6></Col>
                                <Col md="6">Body  <h6>{props.vehicle?.btname.en} - {props.vehicle?.btname.ar}</h6></Col>
                            </Row>
                            <hr />
                            <Row style={{ textAlign: "center" }}>
                                <Col md="3">Interior  <h6>{props.vehicle.intcolor}</h6></Col>
                                <Col md="3">Exterior <h6>{props.vehicle.extcolor}</h6></Col>
                                <Col md="3">Insurence <h6> {props.vehicle.insurence ? "Full" : "Third Party"}</h6></Col>
                                <Col md="3">Running <h6>{props.vehicle.approxmiles}</h6></Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col md="6">Fuel : {props.vehicle.fuelname.en}</Col>
                                <Col md="6"><span style={{ float: "right" }}>Transmission : {props.vehicle?.trmname.en ? props.vehicle?.trmname.en : "NA"}</span></Col>
                            </Row>
                            <hr />
                            {
                                props.vehicle.categoryCode === "1" &&
                                <Table>
                                    <thead style={{ textAlign: "center" }}>
                                        <tr >
                                            <th></th>
                                            <th>Amount</th>
                                            <th>Miles</th>
                                            <th>With Driver</th>
                                            <th>X Miles</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "center" }}>
                                        <tr>
                                            <td>Daily</td>
                                            <td>{props.vehicle?.daily?.amt ? props.vehicle?.daily?.amt : "NA"}</td>
                                            <td>{props.vehicle?.daily?.mileq ? props.vehicle?.daily?.mileq : "NA"}</td>
                                            <td>{props.vehicle?.daily?.wdamt ? props.vehicle?.daily?.wdamt : "NA"}</td>
                                            <td>{props.vehicle?.daily?.xmileq ? props.vehicle?.daily?.xmileq : "NA"}</td>
                                        </tr>
                                        <tr>
                                            <td>Weekly</td>
                                            <td>{props.vehicle?.weekly?.amt ? props.vehicle?.weekly?.amt : "NA"}</td>
                                            <td>{props.vehicle?.weekly?.mileq ? props.vehicle?.weekly?.mileq : "NA"}</td>
                                            <td>{props.vehicle?.weekly?.wdamt ? props.vehicle?.weekly?.wdamt : "NA"}</td>
                                            <td>{props.vehicle?.weekly?.xmileq ? props.vehicle?.weekly?.xmileq : "NA"}</td>
                                        </tr>
                                        <tr>
                                            <td>Monthly </td>
                                            <td>{props.vehicle?.monthly?.amt ? props.vehicle?.monthly?.amt : "NA"}</td>
                                            <td>{props.vehicle?.monthly?.mileq ? props.vehicle?.monthly?.mileq : "NA"}</td>
                                            <td>{props.vehicle?.monthly?.wdamt ? props.vehicle?.monthly?.wdamt : "NA"}</td>
                                            <td>{props.vehicle?.monthly?.xmileq ? props.vehicle?.monthly?.xmileq : "NA"}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            }
                            {
                                props.vehicle.categoryCode !== "1" &&
                                <Table>
                                    <thead style={{ textAlign: "center" }}>
                                        <tr >
                                            <th></th>
                                            <th>Amount</th>
                                            <th>With Crew</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "center" }}>
                                        <tr>
                                            <td>Hourly</td>
                                            <td>{props.vehicle?.hourly?.amt ? props.vehicle?.hourly?.amt : "NA"}</td>
                                            <td>{props.vehicle?.hourly?.wdamt ? props.vehicle?.hourly?.wdamt : "NA"}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            }
                        </Col>
                        <Col style={{ borderLeft: "1px solid lightgray" }}>
                            <b>Features</b>
                            {props.showVehicle()}
                        </Col>
                        <Col style={{ borderLeft: "1px solid lightgray" }}>
                            <Row>
                                <Col>
                                    <label>Additional info</label> :
                                    <p>{props.vehicle?.additionalinfo?.en}</p>
                                    <p>{props.vehicle?.additionalinfo?.fr}</p>
                                    <p>{props.vehicle?.additionalinfo?.ar}</p>
                                </Col>
                            </Row>
                            <hr />
                            <Row style={{ marginTop: 15 }}>
                                <Col>
                                    <label>Documents required for UAE Resident</label> :
                                    <p>{props.vehicle?.documentsrequiredresident?.en}</p>
                                    <p>{props.vehicle?.documentsrequiredresident?.fr}</p>
                                    <p>{props.vehicle?.documentsrequiredresident?.ar}</p>
                                </Col>
                            </Row>
                            <hr />
                            {props.vehicle.categoryCode === "1" &&
                                <Row style={{ marginTop: 15 }}>
                                    <Col>
                                        <label>Documents required for Tourist</label> :
                                        <p>{props.vehicle.documentsrequiredtourist.en}</p>
                                        <p>{props.vehicle.documentsrequiredtourist.fr}</p>
                                        <p>{props.vehicle.documentsrequiredtourist.ar}</p>
                                    </Col>
                                    <Col><span style={{ float: "right" }}>Min Driver Age : {props.vehicle.mindriverage}</span></Col>
                                </Row>

                            }

                            <hr />
                            <Row>
                                {props.vehicle?.categoryCode === "1" && <Col><span>Salik / Toll Charges : {props.vehicle.saliktollcharges}</span></Col>}
                                <Col ><span style={{ float: "right" }}>Security Deposit : {props.vehicle.securitydeposit}</span></Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col><span>Refund Days: {props.vehicle.refunddays}</span></Col>

                            </Row>
                            {props.vehicle?.categoryCode === "2" &&
                                <>
                                    <Row>
                                        <Col><span>Mobilization: {props.vehicle?.mobilizationCharges}</span></Col>
                                        <Col><span style={{ float: "right" }}>Certifications : {props.vehicle.mcertifications}</span></Col>
                                    </Row>
                                    <Row>
                                        <Col><span>Food: {props.vehicle?.mfoodcharges}</span></Col>
                                        <Col><span style={{ float: "right" }}>Accommodation : {props.vehicle?.maccommodationcharges}</span></Col>
                                    </Row>
                                    <Row>
                                        <Col><span>Transport: {props.vehicle?.mtransportcharges}</span></Col>
                                        <Col></Col>
                                    </Row>
                                </>
                            }
                        </Col>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button size="sm" onClick={p => props.setInfom(false)} style={{ float: "right" }}>Close</Button>
                </ModalFooter>

            </Modal>
        );
    } catch (e) {

        return (
            <div></div>
        )
    }

}

export default CreateVInfo;